import Bugsnag from '@bugsnag/js'
import { Libraries, useJsApiLoader } from '@react-google-maps/api'
import EnvironmentService from 'app/lib/services/EnvironmentService'
import { useEffect } from 'react'

const libraries: Libraries = ['places']

let reportedLoadError: Error | undefined
let reportedMissingMaps = false

type Props = {
  isLoaded: boolean
  loadError: Error | undefined
}

export const loadGoogleScripts = (): Props => {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: EnvironmentService.getEnvValue('GOOGLE_MAP_KEY'),
    language: 'de',
    region: 'DE',
    libraries
  })
  const mapsMissing = isLoaded && !window.google?.maps

  useEffect(() => {
    if (!loadError || loadError === reportedLoadError) return
    reportedLoadError = loadError

    console.error(loadError)
    Bugsnag.notify(new Error('Google Maps script failed to load'), (event) => {
      event.severity = 'info'
    })
  }, [loadError])

  useEffect(() => {
    if (!mapsMissing || reportedMissingMaps) return
    reportedMissingMaps = true

    Bugsnag.notify(new Error('Google Maps loaded without window.google.maps'), (event) => {
      event.severity = 'info'
    })
  }, [mapsMissing])

  return { isLoaded: isLoaded && !mapsMissing, loadError }
}
